import { useTranslation } from 'react-i18next'
import { generatePath } from 'react-router-dom'

import {
  RelatedList,
  RelatedListItem,
  RelatedSettings as RelatedSettingsContainer,
} from 'components/RelatedSettings'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { ROUTES } from 'routes'
import { AdUnitForForm } from '../GeneralForm/hooks/useGetAdUnit'

type Props = Pick<AdUnitForForm['domain'], 'id'> &
  Pick<
    AdUnitForForm['domain']['domainViewabilityTools'],
    | 'gamAdRequestMargin'
    | 'kvTargetingAndPrebidAuction'
    | 'lazyLoadTargetingPrebidAuctionEnabled'
    | 'mobileScaling'
  >

export const DomainRelatedSettings = ({
  gamAdRequestMargin,
  id,
  kvTargetingAndPrebidAuction,
  lazyLoadTargetingPrebidAuctionEnabled,
  mobileScaling,
}: Props): JSX.Element => {
  const { t: tc } = useTranslation('common')
  const { t } = useTranslation('features/adUnit', {
    keyPrefix: 'form.viewabilityTools.basicSettings.relatedSettings',
  })

  const { workspaceId } = useWorkspaceParam()

  return (
    <RelatedSettingsContainer title={t('title')}>
      <RelatedList>
        <RelatedListItem
          content={t('lazyLoadTargetingPrebidAuctionEnabled')}
          url={generatePath(ROUTES.INVENTORY.DOMAIN.EDIT, {
            id,
            tab: 'viewability-tools',
            workspaceId,
          })}
          value={tc(`booleanState.${lazyLoadTargetingPrebidAuctionEnabled}`)}
        />
        <RelatedListItem
          content={t('kvTargetingAndPrebidAuction', { value: kvTargetingAndPrebidAuction })}
        />
        <RelatedListItem content={t('gamAdRequestMargin', { value: gamAdRequestMargin })} />
        <RelatedListItem content={t('mobileScaling', { value: mobileScaling })} />
      </RelatedList>
    </RelatedSettingsContainer>
  )
}
